var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content_copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75016 2.50001H3.25016V3.00001V14.1667H2.5835V3.00001C2.5835 2.35949 3.10964 1.83334 3.75016 1.83334H13.2502V2.50001H3.75016ZM16.2502 18.5H16.7502V18V6.33334V5.83334H16.2502H7.0835H6.5835V6.33334V18V18.5H7.0835H16.2502ZM7.0835 5.16668H16.2502C16.8907 5.16668 17.4168 5.69282 17.4168 6.33334V18C17.4168 18.6405 16.8907 19.1667 16.2502 19.1667H7.0835C6.44297 19.1667 5.91683 18.6405 5.91683 18V6.33334C5.91683 5.69282 6.44297 5.16668 7.0835 5.16668Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.b81f3922589f519fbfe51c42483ab9f1.svg";
export { ForwardRef as ReactComponent };